import axios from "axios";
import router from "@/router/router";

//创建axios单例
const instance = axios.create({
  baseURL: "https://a-api.test.fawo.cn/",
  timeout: 3000,
  headers: {
    Accept: "application/vnd.subo_admin.v1+json"
  },
});

//请求拦截器
instance.interceptors.request.use(
  (config) => {
    //在请求发生之前干点啥
    config.headers['Authorization'] = "Bearer " + window.localStorage.getItem('token')
    return config;
  },
  (err) => {
    //对请求错误干点啥
    return Promise.reject(err);
  }
);

//响应拦截器
instance.interceptors.response.use(
  (response) => {
    //对响应数据干点啥
    //判断网络状态码
    if (response.status == 200) {
      const data = response.data;
      //判断业务逻辑状态码
      if (data.status == 200) {
        return data.data;
      }
      //Token过期需要重新登录
      if (data.error_code == 301) {
        console.log('token过期了 ' + window.localStorage.getItem('token'))
        router.push({
          path: '/login'
        }).catch((err) => {
          console.log(err)
        })
      }
      else {
        return Promise.reject({ error_code: 301, message: "业务状态码错误,请检查代码", data });
      }
    } else {
      return Promise.reject({ error_code: 302, message: "响应状态码错误", response });
    }
  },
  (error) => {
    //对响应错误干点啥
    return Promise.reject({ error_code: 303, message: "响应错误", error });
  }
);

export default instance;

export const get = (url, params) => {
  return instance.get(url, { params });
};
export const post = (url, params) => {
  return instance.post(url, params);
};
